import { EntityFieldType } from "@common/entityField.types";
import { InputFieldTypeEnum } from "../entityTemplates/inputFields/InputFields.types";

export function mapInputFieldTypeToContractFieldType(inputFieldType: InputFieldTypeEnum): EntityFieldType {
    switch (inputFieldType) {
        case InputFieldTypeEnum.TextField:
            return EntityFieldType.Text;
        case InputFieldTypeEnum.RichTextField:
            return EntityFieldType.Html;
        case InputFieldTypeEnum.SingleDropDown:
            return EntityFieldType.Text;
        case InputFieldTypeEnum.MultiDropDown:
            return EntityFieldType.Text;
        case InputFieldTypeEnum.DateField:
            return EntityFieldType.Date;
        case InputFieldTypeEnum.NumberField:
        case InputFieldTypeEnum.DatePeriodField:
            return EntityFieldType.Number;
        case InputFieldTypeEnum.AmountField:
        case InputFieldTypeEnum.CalculatedField:
            return EntityFieldType.Amount;
        case InputFieldTypeEnum.CheckboxField:
            return EntityFieldType.Boolean;
        case InputFieldTypeEnum.LegalEntityField:
            return EntityFieldType.EntityList;
        case InputFieldTypeEnum.UserField:
            return EntityFieldType.EntityList;
        case InputFieldTypeEnum.CountryField:
            return EntityFieldType.Countries;
        default:
            return EntityFieldType.Text;
    }
}
